import { useEffect } from 'react'
import useAppDispatch from '../../../hooks/useAppDispatch'
import useAppSelector from '../../../hooks/useAppSelector'
import {
  setEntriesUrl,
  setEntriesUrlFetchInProgress,
} from '../../../features/data/dataSlice'
import { CheckinPageProps } from '../../../pages/CheckinPage'
import { createLogger } from '../../../app/logger'
import { useGetCheckinEntriesQuery } from '../../../api/ctliveApi'
import { getOnlineSelector } from '../../../features/network/networkSlice'
import { getSseOpen } from '../../../features/sse/sseSlice'
import { useEventId } from '../../../app/location'
import CheckinPageWrapperLogic from './CheckinPageWrapperLogic'
import { useSyncChanges } from '../../data/hooks/useSyncChanges'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'CheckinPageWrapper'
})

function CheckinPageWrapper(props: CheckinPageProps) {
  const eventId = useEventId()
  const dispatch = useAppDispatch()
  const online = useAppSelector(getOnlineSelector)
  const sseOpen = useAppSelector(getSseOpen)
  const {
    data: getCheckinEntriesResult,
    isFetching,
  } = useGetCheckinEntriesQuery(eventId, {
    skip: isNaN(eventId) || eventId <= 0 || !online || !sseOpen
  })

  useSyncChanges()

  useEffect(() => {
    dispatch(setEntriesUrlFetchInProgress(isFetching))
  }, [
    dispatch,
    isFetching,
  ])

  useEffect(() => {
    if (getCheckinEntriesResult?.entriesUrl) {
      dispatch(setEntriesUrl(getCheckinEntriesResult.entriesUrl))
    }
  }, [
    dispatch,
    getCheckinEntriesResult,
  ])

  return <CheckinPageWrapperLogic {...props} />
}

export default CheckinPageWrapper
